module.exports = __webpack_public_path__ + "img/es.9151e539.png";